<template>
  <div class="hello">
    <b-row>
    <Header />
    <b-col cols="2" class="left-side"><FilterNav /></b-col>
    <b-col class="right-side"><FilterReq /></b-col>
  </b-row>
  </div>
</template>

<script>
import Header from './Header.vue'
import FilterNav from './FilterNav.vue'
import FilterReq from './FilterReq.vue'

export default {
  name: 'Filter',
  components: {
    Header,
    FilterNav,
    FilterReq
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.left-side{
  height: auto;
  border: 2px inset;
}
.right-side{
  height: auto;
  border: 2px inset;
  margin-left: 2px;
  background: #fff;
}
</style>
